<div class="verification-container">
    <h1>Email Verification In Progress</h1>
    <br>
    <p [ngClass]="{ 'success-message': isSuccess, 'error-message': !isSuccess }">
      {{ verificationStatus }}
    </p>
    <button *ngIf="isSuccess" class="btn btn-primary" (click)="goToLogin()">Go to Login</button>
  </div>